import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../../react-core/Flux/BaseStore";
import { PensionContributionModel } from "../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";
import { EditIncomeWithdrawalsInstructionDispatcher } from "./Variable";

export interface InstructionStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: PensionContributionModel;
    hasCashIsa?: boolean;
}

export class EditIncomeWithdrawalsStatic extends BaseStore<InstructionStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(EditIncomeWithdrawalsInstructionDispatcher, (actionData) =>
        this.onDrawdownAmendmentInstructionStoreResponse(actionData)
        );
    }

    public getLastResult(): InstructionStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading === undefined ? true : this.getState().isLoading;
    }

    public getData() {
        //mock data need to be removed
        const _data: PensionContributionModel = JSON.parse(JSON.stringify(this.getState().data));

        return _data;
    }


    public getHasCashIsa() {
        return this.getState().hasCashIsa;
    }
    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): InstructionStaticState {
        return { actionType: ActionType.Loading, data: null, hasCashIsa: false };
    }

    private onDrawdownAmendmentInstructionStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ isLoading: false, actionType: actionData.actionType, data: actionData.payload });
                break;
            case ActionType.Update:
                this.setState({ actionType: actionData.actionType, hasCashIsa: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: actionData.actionType });
                break;
            case ActionType.Loading:
                this.setState({ actionType: actionData.actionType });
                break;
        }
    }
}
